export default __webpack_public_path__ + "static/media/Inter-Light.e7dd1399.ttf";